import { render } from "./RecursoList.vue?vue&type=template&id=111a18b5&scoped=true"
import script from "./RecursoList.vue?vue&type=script&lang=js"
export * from "./RecursoList.vue?vue&type=script&lang=js"

import "./RecursoList.vue?vue&type=style&index=0&id=111a18b5&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111a18b5"]])

export default __exports__